import { render, staticRenderFns } from "./EnglishStep.vue?vue&type=template&id=2f3b24c7&"
import script from "./EnglishStep.vue?vue&type=script&lang=js&"
export * from "./EnglishStep.vue?vue&type=script&lang=js&"
import style0 from "./EnglishStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports